import React from 'react';
import { Box, Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export interface ChartLegendItemProps {
    id: string;
    label: string;
    color: string;
    hidden: boolean;
    onToggle: (id: string) => void;
}

export const ChartLegendItem: React.FC<ChartLegendItemProps> = ({ id, label, color, hidden, onToggle }) => {
    const handleClick = React.useCallback(() => {
        onToggle(id);
    }, [onToggle, id]);
    return (
        <Box
            onClick={handleClick}
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: 0.5 }}
        >
            {hidden ? (
                <VisibilityOffIcon sx={{ color: 'text.disabled', fontSize: 20 }} />
            ) : (
                <VisibilityIcon sx={{ color, fontSize: 20 }} />
            )}
            <Typography variant="body2" sx={{ color: hidden ? 'text.disabled' : 'text.primary' }}>
                {label}
            </Typography>
        </Box>
    );
};
